import { c as _c } from "react/compiler-runtime";
import { abbreviateAddress } from '@repo/utils';
import type { VaultV2PendingTimelockDecodedData } from '../../types/pendingTimelocks';
import { getTimelockFunctionConfig } from '../utils';
import { StyledVaultPendingTimelock } from '../VaultV2PendingTimelockStyled';
import AdapterItemLink from './AdapterItemLink';
import VaultPendingTimelockHeader from './VaultV2PendingTimelockHeader';
type VaultV2AdapterPendingData = Extract<VaultV2PendingTimelockDecodedData, {
  __typename: 'VaultV2AdapterPendingData';
}>;
interface VaultV2PendingTimelockAddAdapterProps {
  decodedData: VaultV2AdapterPendingData;
  functionName: string;
}
const VaultV2PendingTimelockAddAdapter = t0 => {
  const $ = _c(12);
  const {
    decodedData,
    functionName
  } = t0;
  let t1;
  if ($[0] !== functionName) {
    t1 = getTimelockFunctionConfig({
      functionName
    });
    $[0] = functionName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    criticality
  } = t1;
  const label = decodedData.adapter?.__typename === "MetaMorphoAdapter" ? "Add vault V1 adapter" : decodedData.adapter?.__typename === "MorphoMarketV1Adapter" ? "Add market V1 adapter" : "Add adapter";
  let t2;
  if ($[2] !== criticality || $[3] !== label) {
    t2 = <VaultPendingTimelockHeader title={label} criticality={criticality} />;
    $[2] = criticality;
    $[3] = label;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="text-2xs text-foreground">Item</span>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== decodedData.adapter || $[7] !== decodedData.adapterAddress) {
    t4 = <StyledVaultPendingTimelock.Row>{t3}<span className="text-2xs text-foreground min-w-0">{decodedData.adapter ? <AdapterItemLink adapter={decodedData.adapter} /> : <span className="text-2xs text-foreground">{abbreviateAddress(decodedData.adapterAddress)}</span>}</span></StyledVaultPendingTimelock.Row>;
    $[6] = decodedData.adapter;
    $[7] = decodedData.adapterAddress;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className="flex flex-col">{t2}{t4}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default VaultV2PendingTimelockAddAdapter;